/**
 * The Drievlag-trap mark rendered on the blue brand surface ("ondark" variant
 * from the mockup): three ascending rounded bars in lightened flag tints so they
 * read on the accent gradient. Flag hexes are the brand.md §2 logo exception.
 */
export function OnboardingLogo() {
  return (
    <span aria-hidden="true" className="inline-flex items-end gap-1">
      <i className="block w-2 rounded-[3px]" style={{ height: 15, background: "#9db8e6" }} />
      <i className="block w-2 rounded-[3px]" style={{ height: 22, background: "#ffffff" }} />
      <i className="block w-2 rounded-[3px]" style={{ height: 29, background: "#f0808f" }} />
    </span>
  );
}
